import { globalVariables } from "helper/globalVariables";
import { forwardRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { OutlineButton } from "shared/Components/outlineButton";
import { TextInput } from "shared/Components/textInput";
import DatePicker from "shared/Components/datepicker";
import Dropdown from "shared/Components/dropdown";
import { client } from "helper/apolloConfig";
import { UpdateTrailResultDetailsMutation } from "../../../../redux/features/trailResultSlice/trailResultGql";
import { close } from "helper/icons";

export const EditNAEResult = forwardRef((props, ref) => {
  const { initialData, onUpdateSuccessful } = props || {};
  const [loading, setLoading] = useState(false);

  const onHandleSubmit = async (data) => {
    getDashboardData(initialData.id, data);
    setLoading(true);
  };

  const getDashboardData = async (id, data) => {
    try {
      const tempData = {
        div: data.div,
        hidesFound: data.hidesFound,
        faultReason: data.faultReason,
        hidesSet: data.hidesSet,
        points: data.points,
        place: parseInt(data.place),
        timeLimit: data.timeLimit,
        faults: data.faults,
        ngReason: data.faultReason,
        time: data.time,
        judgeNotes: data.judgeNotes,
        searchName: initialData.searchName,
        trialCalendarId: initialData.trialCalendarId,
        dogId: initialData.dogId,
        date: new Date(data.date),
        search: data.search,
        handler: data.handler,
        trialLocation: data.trialLocation,
        breed: data.breed,
        dog: data.dog,
        qNq: data.qNq
      };

      console.log("handle submt data", tempData);
      const res = await client.mutate({
        mutation: UpdateTrailResultDetailsMutation,
        variables: {
          id: parseInt(id),
          data: tempData,
        },
        fetchPolicy: "network-only",
      });
      setLoading(false);
      ref.current.closeModal();
      onUpdateSuccessful();
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const { register, handleSubmit, setValue, getValues } = useForm({});

  useEffect(() => {
    if (initialData) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
    }
  }, [initialData, setValue]);

  return (
    <Modal
      extraClass={"w-[400px] pt-0"}
      headerClass="sticky top-6 left-100 z-50"
      iconPosition="right-0"
      showClose={false}
      ref={ref}
    >
      <div className="bg-white">
        <div className="sticky flex justify-between flex-row">
          <div className="flex justify-start  flex-col pb-3  top-0  bg-white pt-4 z-50">
            <span className="text-lg font-semibold text-gray-900">
              Edit Results
            </span>
          </div>
          <button
            onClick={(e) => {
              ref.current.closeModal();
            }}
            className={`text-gray-500 hover:text-gray-700 focus:outline-none`}
          >
            <img src={close} alt="" className="h-6 w-6" />
          </button>
        </div>
        <form
          className="items-center flex flex-1 gap-2 flex-col h-[80vh] "
          onSubmit={handleSubmit(onHandleSubmit)}
        >
          <div className="flex flex-row gap-2">
            <div>
              <TextInput
                width="w-[170px]"
                label="Trial Location"
                placeholder="trialLocation"
                register={register}
                name="trialLocation"
              />
            </div>

            <DatePicker
              label="Date"
              width="w-[170px]"
              defaultDate={new Date(initialData.date)}
              onSetDate={(date) => setValue("data", new Date(date))}
            />
          </div>
          <div className="flex flex-row justify-center gap-2">
            <TextInput
              width="w-[170px]"
              label="Search"
              placeholder="Search"
              register={register}
              name="search"
              disabled
            />
            <TextInput
              width="w-[170px]"
              label="Handler"
              placeholder="handler"
              register={register}
              name="handler"
            />
          </div>

          <div className="flex flex-row justify-center gap-2">
            <TextInput
              width="w-[170px]"
              label="Dog"
              placeholder="dog"
              register={register}
              name="dog"
            />
            <TextInput
              width="w-[170px]"
              label="Breed"
              placeholder="breed"
              register={register}
              name="breed"
            />
          </div>

          <div className="flex flex-row justify-center gap-2">
            <TextInput
              width="w-[170px]"
              label="Div"
              placeholder="div"
              register={register}
              name="div"
            />
            <Dropdown
              width="w-[170px]"
              label="Q/NQ"
              defaultOption={initialData.qNq}
              onChange={(options) => setValue("qNq", options)}
              dropdownOptions={["Q", "NQ"]}
            />
          </div>

          <div className="flex flex-row justify-center gap-2 ">
            <TextInput
              width="w-[350px]"
              label="NQ Reason"
              placeholder="faultReason"
              register={register}
              name="faultReason"
            />
          </div>

          <div className="flex flex-row justify-center gap-2">
            <TextInput
              width="w-[170px]"
              label="Time"
              placeholder="time"
              register={register}
              name="time"
            />
            <TextInput
              width="w-[170px]"
              label="Hide Founds"
              placeholder="hidesFound"
              register={register}
              name="hidesFound"
            />
          </div>

          <div className="flex flex-row justify-center gap-2">
            <TextInput
              width="w-[170px]"
              label="# of Faults"
              placeholder="Faults"
              register={register}
              name="faults"
            />
            <TextInput
              width="w-[170px]"
              label="Fault Reason"
              placeholder="Fault Reason"
              register={register}
              name="faultReason"
            />
          </div>

          <div className="flex flex-row justify-center gap-2">
            <TextInput
              width="w-[170px]"
              label="Points"
              placeholder="points"
              register={register}
              name="points"
            />
            <TextInput
              width="w-[170px]"
              label="Place"
              placeholder="Place"
              register={register}
              name="place"
            />
          </div>

          <div className="flex flex-row justify-center gap-2">
            <TextInput
              width="w-[170px]"
              label="Time Limit"
              placeholder="Time Limit"
              register={register}
              name="timeLimit"
            />
            <TextInput
              width="w-[170px]"
              label="Hide Set"
              placeholder="Hide Set"
              register={register}
              name="hidesSet"
            />
          </div>
          <div className="flex flex-row justify-center gap-2">
            <TextInput
              width="w-[350px]"
              label="Judge Notes"
              placeholder="judgeNotes"
              register={register}
              name="judgeNotes"
            />
          </div>
          <div className="mb-6" />
          <div className="flex flex-row justify-center gap-2">
            <OutlineButton
              onClick={() => {
                ref.current?.closeModal();
              }}
              width={"lg:w-[170px] w-[140px]"}
              label={globalVariables.cancel}
            />
            <Button
              type="submit"
              width={"lg:w-[170px] w-[140px]"}
              label={globalVariables.submit}
              disabled={loading}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
});
